// src/components/TabBar.js (Updated)
import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaExchangeAlt, FaWallet, FaCog, FaHistory, FaGlobe } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { AuthUIContext } from './Auth/AuthWrapper'; // Import the AuthUIContext
import './TabBar.css';

const TabBar = () => {
  const location = useLocation();
  const { t } = useTranslation();
  
  // Access the authentication UI state
  const { isAuthenticating } = useContext(AuthUIContext);
  
  // Don't render TabBar when authentication UI is showing
  if (isAuthenticating) {
    return null;
  }

  // Helper function to determine if a path is active
  const isActive = (path) => location.pathname === path;

  return (
    <div className="tabbar">
      <Link to="/wallet" className={`tab-link ${isActive('/wallet') ? 'active' : ''}`}>
        <div className="tab-icon-container">
          <FaWallet className="tab-icon" />
        </div>
        <span className="tab-label">{t('navigation.wallet')}</span>
        <div className="tab-indicator"></div>
      </Link>
      
      <Link to="/swap" className={`tab-link ${isActive('/swap') ? 'active' : ''}`}>
        <div className="tab-icon-container">
          <FaExchangeAlt className="tab-icon" />
        </div>
        <span className="tab-label">{t('navigation.swap')}</span>
        <div className="tab-indicator"></div>
      </Link>

      <Link to="/browser" className={`tab-link ${isActive('/browser') ? 'active' : ''}`}>
        <div className="tab-icon-container">
          <FaGlobe className="tab-icon" />
        </div>
        <span className="tab-label">{t('navigation.browser')}</span>
        <div className="tab-indicator"></div>
      </Link>
      
      <Link to="/transactions" className={`tab-link ${isActive('/transactions') ? 'active' : ''}`}>
        <div className="tab-icon-container">
          <FaHistory className="tab-icon" />
        </div>
        <span className="tab-label">{t('navigation.transactions')}</span>
        <div className="tab-indicator"></div>
      </Link>

      <Link to="/settings" className={`tab-link ${isActive('/settings') ? 'active' : ''}`}>
        <div className="tab-icon-container">
          <FaCog className="tab-icon" />
        </div>
        <span className="tab-label">{t('navigation.settings')}</span>
        <div className="tab-indicator"></div>
      </Link>
    </div>
  );
};

export default TabBar;